const MYRtarspayOptions = [
    {value: "PUBLIC_BANK", label: "PUBLIC BANK"},
    {value: "CIMB", label: "CIMB"},
    {value: "HONG_LEONG", label: "Hong Leong"},
    {value: "HSBC", label: "HSBC"},
    {value: "UNITED_OVERSEAS_BANK", label: "United Overseas Bank (Malaysia)"},
    {value: "BANK_SIMPANAN_NASIONAL", label: "Bank Simpanan Nasional"},
    {value: "MAYBANK", label: "Maybank"},
    {value: "RHB", label: "RHB"},
    {value: "BSN", label: "BSN"},
    {value: "AMBANK", label: "Ambank"},
    {value: "UOB", label: "UOB"},
    {value: "ALLIANCE_BANK", label: "Alliance Bank"},
    {value: "BANK_RAKYAT", label: "Bank Rakyat"},
    {value: "OCBC_BANK", label: "OCBC Bank (Malaysia)"},
    {value: "AFFIN_BANK", label: "Affin Bank"},
    {value: "BANK_ISLAM", label: "Bank Islam"},
    {value: "STANDARD_CHARTERED_BANK", label: "Standard Chartered Bank"},
    {value: "BANK_MUAMALAT", label: "Bank Muamalat"},
    {value: "AGRO_BANK", label: "Agro Bank"},
    {value: "TOUCH 'N_GO", label: "Touch 'n Go"},
    {value: "CITIBANK", label: "Citibank"},
    {value: "BOOST", label: "Boost"},
    {value: "GRABPAY", label: "GrabPay"},
    {value: "WECHAT_PAY", label: "Wechat Pay"},
    {value: "MAE", label: "MAE"},
    {value: "BIGPAY", label: "BigPay"},
    {value: "SHOPEEPAY", label: "ShopeePay"},
];

export default MYRtarspayOptions;
